/**
 * description: 日期工具类
 * dateTime: 2024/8/31-下午3:23
 * author: ZhangJun 1580043700@qq.com
 */
import dayjs from 'dayjs'

/**
 * 格式化日期
 * @param date
 * @param fmt
 */
export const dateFormat = (
  date: any,
  fmt: 'YYYY-MM-DD' | 'YYYY-MM-DD HH:mm:ss' | 'HH:mm:ss' | string = 'YYYY-MM-DD'
) => {
  return date ? dayjs(date).format(fmt) : null
}

/**
 * 日期转dayjs
 * @param date
 * @param defaultDate
 */
export const date2Dayjs = (date: any, defaultDate: any = null) => {
  return date ? dayjs(date) : defaultDate
}
export const  convertMillisecondsToTime = (milliseconds) =>{
  // 将毫秒转换为秒
  const totalSeconds = Math.floor(milliseconds / 1000);
  
  // 计算天数
  const days = Math.floor(totalSeconds / (3600 * 24));
  
  // 计算剩余秒数
  const remainingSeconds = totalSeconds % (3600 * 24);
  
  // 计算小时数
  const hours = Math.floor(remainingSeconds / 3600);
  
  // 计算剩余秒数
  const remainingSecondsAfterHours = remainingSeconds % 3600;
  
  // 计算分钟数
  const minutes = Math.floor(remainingSecondsAfterHours / 60);
  
  // 计算最终秒数
  const seconds = remainingSecondsAfterHours % 60;
  
  return {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
}